import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";

const ProductCrudTableRow = ({ el, i, editData, deleteData, setModalShow, setProduct }) => {
    let myAbilities = HelpAbility();
    let {/* code, */ sku, skuHijo, name, priceWithoutIva, discount, iva, haveStock, _id, stockCenters } = el;

    // convertir a número primero
    const priceWithoutIvaNum = priceWithoutIva ? Number(priceWithoutIva) : "";
    const discountNum = discount ? Number(discount) : "";
    const ivaNum = iva ? Number(iva) : "";

    // cálculos
    const netPrice = priceWithoutIvaNum && discountNum ? priceWithoutIvaNum - discountNum : "";
    const totalPrice = netPrice && ivaNum ? netPrice + ivaNum : "";

    // función para formatear miles
    const formatNumber = (num) =>
        num.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // valores formateados para mostrar
    const priceWithoutIvaFormat = formatNumber(priceWithoutIvaNum);
    const discountFormat = formatNumber(discountNum);
    const netPriceFormat = formatNumber(netPrice);
    const ivaFormat = formatNumber(ivaNum);
    const totalPriceFormat = formatNumber(totalPrice);

    const handleCenter = ({ product }) => {
        setProduct({ ...product });
        setModalShow(true);
    }
    return (
        <tr>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{sku}</td>
            <td className="text-center">{skuHijo}</td>
            <td>{name}</td>
            <td className="text-center">{'$ ' + priceWithoutIvaFormat}</td>
            <td className="text-center">{'$ ' + discountFormat}</td>
            <td className="text-center">{'$ ' + netPriceFormat}</td>
            <td className="text-center">{'$ ' + ivaFormat}</td>
            <td className="text-center">{'$ ' + totalPriceFormat}</td>
            <td className="text-center">{haveStock ? 'Si' : 'No'}</td>
            <td className="text-center">{stockCenters?.length || 0}</td>
            {myAbilities.hasAny([C.A.PRODUCT.UPDATE, C.A.PRODUCT.DELETE, C.A.CENTER.LINK]) &&
                <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                        {myAbilities.has(C.A.CENTER.LINK) && <OverlayTrigger placement="top"
                            overlay={<Tooltip
                                id="tooltip-top">Gestión de Centros</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-info me-2 text-white"
                                onClick={() => handleCenter({ product: el })}>
                                <i className="bi bi-house-door" />
                            </button>
                        </OverlayTrigger>}

                        {myAbilities.has(C.A.PRODUCT.UPDATE) && <OverlayTrigger placement="top"
                            overlay={<Tooltip
                                id="tooltip-top">Editar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-success me-2"
                                onClick={() => editData(el)}>
                                <i className="bi bi-pencil-square" />
                            </button>
                        </OverlayTrigger>}
                        {myAbilities.has(C.A.PRODUCT.DELETE) && <OverlayTrigger placement="top"
                            overlay={<Tooltip
                                id="tooltip-top">Eliminar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => deleteData(_id)}>
                                <i className="bi bi-trash" />
                            </button>
                        </OverlayTrigger>}
                    </div>
                </td>
            }
        </tr>
    )
};

export default ProductCrudTableRow;
